// @ts-nocheck
/**
* ATTENTION!
* @generated THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
*/

import * as Types from '../schema';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type CommunicationUnreadTotalQueryVariables = Types.Exact<{
  workspaceId: Types.Scalars['String']['input'];
}>;


export type CommunicationUnreadTotalQuery = { __typename?: 'Query', communicationUnreadTotal: number };

export type CommunicationNotificationsQueryVariables = Types.Exact<{
  input: Types.CommunicationNotificationPageInput;
}>;


export type CommunicationNotificationsQuery = { __typename?: 'Query', communicationNotifications: Array<{ __typename?: 'CommunicationNotification', id: string, workspaceId: string, conversationId: string, sender: string, excerpt: string, acknowledgedAt?: any | null, resolvedAt?: any | null, updatedAt: any }> };

export type CommunicationNotificationPreferenceQueryVariables = Types.Exact<{
  workspaceId: Types.Scalars['String']['input'];
}>;


export type CommunicationNotificationPreferenceQuery = { __typename?: 'Query', communicationNotificationPreference: { __typename?: 'CommunicationNotificationPreference', push: boolean, email: boolean, vapidPublicKey?: string | null } };

export type AcknowledgeCommunicationNotificationsMutationVariables = Types.Exact<{
  workspaceId: Types.Scalars['String']['input'];
  ids: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type AcknowledgeCommunicationNotificationsMutation = { __typename?: 'Mutation', acknowledgeCommunicationNotifications: boolean };

export type SetCommunicationNotificationPreferenceMutationVariables = Types.Exact<{
  input: Types.CommunicationNotificationPreferenceInput;
}>;


export type SetCommunicationNotificationPreferenceMutation = { __typename?: 'Mutation', setCommunicationNotificationPreference: { __typename?: 'CommunicationNotificationPreference', push: boolean, email: boolean } };

export type RegisterCommunicationPushSubscriptionMutationVariables = Types.Exact<{
  input: Types.CommunicationPushSubscriptionInput;
}>;


export type RegisterCommunicationPushSubscriptionMutation = { __typename?: 'Mutation', registerCommunicationPushSubscription: boolean };

export type RemoveCommunicationPushSubscriptionMutationVariables = Types.Exact<{
  endpoint: Types.Scalars['String']['input'];
}>;


export type RemoveCommunicationPushSubscriptionMutation = { __typename?: 'Mutation', removeCommunicationPushSubscription: boolean };


export const CommunicationUnreadTotalDocument = gql`
    query CommunicationUnreadTotal($workspaceId: String!) {
  communicationUnreadTotal(workspaceId: $workspaceId)
}
    `;

/**
 * __useCommunicationUnreadTotalQuery__
 *
 * To run a query within a React component, call `useCommunicationUnreadTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunicationUnreadTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunicationUnreadTotalQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useCommunicationUnreadTotalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CommunicationUnreadTotalQuery, CommunicationUnreadTotalQueryVariables> & ({ variables: CommunicationUnreadTotalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CommunicationUnreadTotalQuery, CommunicationUnreadTotalQueryVariables>(CommunicationUnreadTotalDocument, options);
      }
export function useCommunicationUnreadTotalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CommunicationUnreadTotalQuery, CommunicationUnreadTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CommunicationUnreadTotalQuery, CommunicationUnreadTotalQueryVariables>(CommunicationUnreadTotalDocument, options);
        }
// @ts-ignore
export function useCommunicationUnreadTotalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CommunicationUnreadTotalQuery, CommunicationUnreadTotalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CommunicationUnreadTotalQuery, CommunicationUnreadTotalQueryVariables>;
export function useCommunicationUnreadTotalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CommunicationUnreadTotalQuery, CommunicationUnreadTotalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CommunicationUnreadTotalQuery | undefined, CommunicationUnreadTotalQueryVariables>;
export function useCommunicationUnreadTotalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CommunicationUnreadTotalQuery, CommunicationUnreadTotalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CommunicationUnreadTotalQuery, CommunicationUnreadTotalQueryVariables>(CommunicationUnreadTotalDocument, options);
        }
export type CommunicationUnreadTotalQueryHookResult = ReturnType<typeof useCommunicationUnreadTotalQuery>;
export type CommunicationUnreadTotalLazyQueryHookResult = ReturnType<typeof useCommunicationUnreadTotalLazyQuery>;
export type CommunicationUnreadTotalSuspenseQueryHookResult = ReturnType<typeof useCommunicationUnreadTotalSuspenseQuery>;
export type CommunicationUnreadTotalQueryResult = ApolloReactCommon.QueryResult<CommunicationUnreadTotalQuery, CommunicationUnreadTotalQueryVariables>;
export const CommunicationNotificationsDocument = gql`
    query CommunicationNotifications($input: CommunicationNotificationPageInput!) {
  communicationNotifications(input: $input) {
    id
    workspaceId
    conversationId
    sender
    excerpt
    acknowledgedAt
    resolvedAt
    updatedAt
  }
}
    `;

/**
 * __useCommunicationNotificationsQuery__
 *
 * To run a query within a React component, call `useCommunicationNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunicationNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunicationNotificationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCommunicationNotificationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CommunicationNotificationsQuery, CommunicationNotificationsQueryVariables> & ({ variables: CommunicationNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CommunicationNotificationsQuery, CommunicationNotificationsQueryVariables>(CommunicationNotificationsDocument, options);
      }
export function useCommunicationNotificationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CommunicationNotificationsQuery, CommunicationNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CommunicationNotificationsQuery, CommunicationNotificationsQueryVariables>(CommunicationNotificationsDocument, options);
        }
// @ts-ignore
export function useCommunicationNotificationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CommunicationNotificationsQuery, CommunicationNotificationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CommunicationNotificationsQuery, CommunicationNotificationsQueryVariables>;
export function useCommunicationNotificationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CommunicationNotificationsQuery, CommunicationNotificationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CommunicationNotificationsQuery | undefined, CommunicationNotificationsQueryVariables>;
export function useCommunicationNotificationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CommunicationNotificationsQuery, CommunicationNotificationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CommunicationNotificationsQuery, CommunicationNotificationsQueryVariables>(CommunicationNotificationsDocument, options);
        }
export type CommunicationNotificationsQueryHookResult = ReturnType<typeof useCommunicationNotificationsQuery>;
export type CommunicationNotificationsLazyQueryHookResult = ReturnType<typeof useCommunicationNotificationsLazyQuery>;
export type CommunicationNotificationsSuspenseQueryHookResult = ReturnType<typeof useCommunicationNotificationsSuspenseQuery>;
export type CommunicationNotificationsQueryResult = ApolloReactCommon.QueryResult<CommunicationNotificationsQuery, CommunicationNotificationsQueryVariables>;
export const CommunicationNotificationPreferenceDocument = gql`
    query CommunicationNotificationPreference($workspaceId: String!) {
  communicationNotificationPreference(workspaceId: $workspaceId) {
    push
    email
    vapidPublicKey
  }
}
    `;

/**
 * __useCommunicationNotificationPreferenceQuery__
 *
 * To run a query within a React component, call `useCommunicationNotificationPreferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunicationNotificationPreferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunicationNotificationPreferenceQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useCommunicationNotificationPreferenceQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CommunicationNotificationPreferenceQuery, CommunicationNotificationPreferenceQueryVariables> & ({ variables: CommunicationNotificationPreferenceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CommunicationNotificationPreferenceQuery, CommunicationNotificationPreferenceQueryVariables>(CommunicationNotificationPreferenceDocument, options);
      }
export function useCommunicationNotificationPreferenceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CommunicationNotificationPreferenceQuery, CommunicationNotificationPreferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CommunicationNotificationPreferenceQuery, CommunicationNotificationPreferenceQueryVariables>(CommunicationNotificationPreferenceDocument, options);
        }
// @ts-ignore
export function useCommunicationNotificationPreferenceSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CommunicationNotificationPreferenceQuery, CommunicationNotificationPreferenceQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CommunicationNotificationPreferenceQuery, CommunicationNotificationPreferenceQueryVariables>;
export function useCommunicationNotificationPreferenceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CommunicationNotificationPreferenceQuery, CommunicationNotificationPreferenceQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CommunicationNotificationPreferenceQuery | undefined, CommunicationNotificationPreferenceQueryVariables>;
export function useCommunicationNotificationPreferenceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CommunicationNotificationPreferenceQuery, CommunicationNotificationPreferenceQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CommunicationNotificationPreferenceQuery, CommunicationNotificationPreferenceQueryVariables>(CommunicationNotificationPreferenceDocument, options);
        }
export type CommunicationNotificationPreferenceQueryHookResult = ReturnType<typeof useCommunicationNotificationPreferenceQuery>;
export type CommunicationNotificationPreferenceLazyQueryHookResult = ReturnType<typeof useCommunicationNotificationPreferenceLazyQuery>;
export type CommunicationNotificationPreferenceSuspenseQueryHookResult = ReturnType<typeof useCommunicationNotificationPreferenceSuspenseQuery>;
export type CommunicationNotificationPreferenceQueryResult = ApolloReactCommon.QueryResult<CommunicationNotificationPreferenceQuery, CommunicationNotificationPreferenceQueryVariables>;
export const AcknowledgeCommunicationNotificationsDocument = gql`
    mutation AcknowledgeCommunicationNotifications($workspaceId: String!, $ids: [String!]!) {
  acknowledgeCommunicationNotifications(workspaceId: $workspaceId, ids: $ids)
}
    `;

/**
 * __useAcknowledgeCommunicationNotificationsMutation__
 *
 * To run a mutation, you first call `useAcknowledgeCommunicationNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcknowledgeCommunicationNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acknowledgeCommunicationNotificationsMutation, { data, loading, error }] = useAcknowledgeCommunicationNotificationsMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useAcknowledgeCommunicationNotificationsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcknowledgeCommunicationNotificationsMutation, AcknowledgeCommunicationNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcknowledgeCommunicationNotificationsMutation, AcknowledgeCommunicationNotificationsMutationVariables>(AcknowledgeCommunicationNotificationsDocument, options);
      }
export type AcknowledgeCommunicationNotificationsMutationHookResult = ReturnType<typeof useAcknowledgeCommunicationNotificationsMutation>;
export type AcknowledgeCommunicationNotificationsMutationResult = ApolloReactCommon.MutationResult<AcknowledgeCommunicationNotificationsMutation>;
export const SetCommunicationNotificationPreferenceDocument = gql`
    mutation SetCommunicationNotificationPreference($input: CommunicationNotificationPreferenceInput!) {
  setCommunicationNotificationPreference(input: $input) {
    push
    email
  }
}
    `;

/**
 * __useSetCommunicationNotificationPreferenceMutation__
 *
 * To run a mutation, you first call `useSetCommunicationNotificationPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCommunicationNotificationPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCommunicationNotificationPreferenceMutation, { data, loading, error }] = useSetCommunicationNotificationPreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetCommunicationNotificationPreferenceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetCommunicationNotificationPreferenceMutation, SetCommunicationNotificationPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetCommunicationNotificationPreferenceMutation, SetCommunicationNotificationPreferenceMutationVariables>(SetCommunicationNotificationPreferenceDocument, options);
      }
export type SetCommunicationNotificationPreferenceMutationHookResult = ReturnType<typeof useSetCommunicationNotificationPreferenceMutation>;
export type SetCommunicationNotificationPreferenceMutationResult = ApolloReactCommon.MutationResult<SetCommunicationNotificationPreferenceMutation>;
export const RegisterCommunicationPushSubscriptionDocument = gql`
    mutation RegisterCommunicationPushSubscription($input: CommunicationPushSubscriptionInput!) {
  registerCommunicationPushSubscription(input: $input)
}
    `;

/**
 * __useRegisterCommunicationPushSubscriptionMutation__
 *
 * To run a mutation, you first call `useRegisterCommunicationPushSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterCommunicationPushSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerCommunicationPushSubscriptionMutation, { data, loading, error }] = useRegisterCommunicationPushSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterCommunicationPushSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RegisterCommunicationPushSubscriptionMutation, RegisterCommunicationPushSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RegisterCommunicationPushSubscriptionMutation, RegisterCommunicationPushSubscriptionMutationVariables>(RegisterCommunicationPushSubscriptionDocument, options);
      }
export type RegisterCommunicationPushSubscriptionMutationHookResult = ReturnType<typeof useRegisterCommunicationPushSubscriptionMutation>;
export type RegisterCommunicationPushSubscriptionMutationResult = ApolloReactCommon.MutationResult<RegisterCommunicationPushSubscriptionMutation>;
export const RemoveCommunicationPushSubscriptionDocument = gql`
    mutation RemoveCommunicationPushSubscription($endpoint: String!) {
  removeCommunicationPushSubscription(endpoint: $endpoint)
}
    `;

/**
 * __useRemoveCommunicationPushSubscriptionMutation__
 *
 * To run a mutation, you first call `useRemoveCommunicationPushSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCommunicationPushSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCommunicationPushSubscriptionMutation, { data, loading, error }] = useRemoveCommunicationPushSubscriptionMutation({
 *   variables: {
 *      endpoint: // value for 'endpoint'
 *   },
 * });
 */
export function useRemoveCommunicationPushSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveCommunicationPushSubscriptionMutation, RemoveCommunicationPushSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveCommunicationPushSubscriptionMutation, RemoveCommunicationPushSubscriptionMutationVariables>(RemoveCommunicationPushSubscriptionDocument, options);
      }
export type RemoveCommunicationPushSubscriptionMutationHookResult = ReturnType<typeof useRemoveCommunicationPushSubscriptionMutation>;
export type RemoveCommunicationPushSubscriptionMutationResult = ApolloReactCommon.MutationResult<RemoveCommunicationPushSubscriptionMutation>;